// extracted by mini-css-extract-plugin
module.exports = {"Button":"BookmarkButton_Button__1J2FR","inactive":"BookmarkButton_inactive__2VOxv","clicked":"BookmarkButton_clicked__3nFSJ"};